import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';

// Ultrahuman × Luminary acquisition flow for the Ring PRO buy page
// (`/ring-pro/buy?flow=luminary`). US-only, so this is a Partial map rather
// than the full Record every other addon uses.
//
// The offer is 19% off the Ring PRO line + 6 months of Cycle & Ovulation Pro
// included free. Because CNO Pro is bundled, the CNO Pro selector is hidden in
// this flow (see ProductSelectionSection).
//
// Annotated `boolean` on purpose: without it TS narrows to the literal `false`
// and collapses every branch that depends on it.
export const LUMINARY_FLOW_ENABLED: boolean = true;

export type LuminaryFlowConfig = {
  discountCode: string;
  ringDiscountPercentage: number;
  cnoPro: {
    months: number;
    variantId: string;
  };
};

export const LuminaryFlowShopifyMap: Partial<
  Record<ShopifyStore, LuminaryFlowConfig>
> = {
  [ShopifyStore.US]: {
    discountCode: 'BXH6R0CC2Z0K',
    ringDiscountPercentage: 19,
    cnoPro: {
      months: 6,
      variantId: 'gid://shopify/ProductVariant/42985702555744',
    },
  },
};
